@if (clinicalNote(); as note) {
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2 font-semibold">
      <p>
        Recorded On: {{ note.recordDate | moment | amDateFormat: dateFormat }}
      </p>
      <p>Recorded By: {{ note.owner.name }}</p>
    </div>
    <pr-content-view [content]="note.content" />
  </div>
}
